module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/hall-list/plan-photowedding-lineup-kansai-3-1dc0b4024ee5eabdaea9f8e4262432da.png";